import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const statusBadgeClass = status => {
	switch ((status || '').toLowerCase()) {
		case 'assigned':
			return 'bg-blue-100 text-blue-800'
		case 'completed':
			return 'bg-amber-100 text-amber-800'
		case 'approved':
			return 'bg-green-100 text-green-800'
		case 'paid':
			return 'bg-emerald-100 text-emerald-800'
		default:
			return 'bg-gray-100 text-gray-800'
	}
}

export default function TrainingsTableRow({ training, onDelete }) {
	const { t } = useTranslation()
	const startDate = training.data_rozpoczecia || training.trainingDate
	const endDate = training.data_zakonczenia || training.trainingEndDate
	const trainingStartDate = startDate ? startDate.substring(0, 10) : '—'
	const trainingEndDate = endDate ? endDate.substring(0, 10) : trainingStartDate
	const trainingDate = trainingStartDate === trainingEndDate
		? trainingStartDate
		: `${trainingStartDate} - ${trainingEndDate}`
	const statusLabel = training.status
		? t(`trainings.list.statusOptions.${training.status}`, { defaultValue: training.status })
		: '—'
	const trainers = Array.isArray(training.trainerNames) ? training.trainerNames : []
	const rawPlacowkaId = training?.placowkaId || training?.id_placowka || null
	const placowkaId = typeof rawPlacowkaId === 'object'
		? rawPlacowkaId?._id || rawPlacowkaId?.id || null
		: rawPlacowkaId
	const placowkaName = training.placowkaName || '—'

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200">
				<Link
					to={`/centrumSzkolen/szkolenia/details/${training._id}`}
					className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{training.nazwa || training.trainingName || '—'}
				</Link>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 max-w-[280px]">
				<div className="truncate" title={placowkaName}>
					{placowkaId && training.placowkaName ? (
						<Link
							to={`/klienci/placowki/details/${placowkaId}`}
							className="block truncate text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
						>
							{placowkaName}
						</Link>
					) : (
						<span className="text-gray-900">{placowkaName}</span>
					)}
				</div>
				{training.placowkaAddress && (
					<div className="mt-1 text-xs text-gray-500 truncate" title={training.placowkaAddress}>
						{training.placowkaAddress}
					</div>
				)}
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-gray-900 whitespace-nowrap">
				<div className="flex flex-wrap gap-1">
					{trainers.length
						? trainers.map((trainer, index) => (
							<span
								key={`${training._id}-trainer-${index}`}
								className="px-2 py-0.5 text-xs rounded-full bg-slate-100 text-slate-700 border border-slate-200"
							>
								{trainer}
							</span>
						))
						: <span className="text-gray-900">{t('trainings.list.table.unassignedTrainer')}</span>}
				</div>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap">
				<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
					{trainingDate}
				</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap">
				<span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusBadgeClass(training.status)}`}>
					{statusLabel}
				</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-right">
				<div className="inline-flex items-center gap-2">
					<Link
						to={`/centrumSzkolen/szkolenia/edit/${training._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
					>
						<PencilIcon className="h-4 w-4" />
						{t('trainings.list.table.edit')}
					</Link>
					<button
						type="button"
						onClick={() => onDelete(training)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100"
					>
						<TrashIcon className="h-4 w-4" />
						<span>{t('trainings.list.table.delete')}</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
